import { render, staticRenderFns } from "./ConfirmacaoForm.vue?vue&type=template&id=704221f5&"
import script from "./ConfirmacaoForm.vue?vue&type=script&lang=js&"
export * from "./ConfirmacaoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports